import styled from "styled-components";



export const StyledNavbarSection = styled.div`
width: 100%;
height: 80px;
background-color: rgba(249, 250, 251, .75);
/* background:transparent; */
display: flex;
justify-content: space-between;
position: fixed;
top: 0;
left: 0;
right: 0;
z-index: 999;
`
export const StyledNavbarLogoSection = styled.div`

width: 24%;
height: 80px;
background-color: rgba(249, 250, 251, .75);
display: flex;
padding-left: 10px;
    align-items: center;
&:hover{
    cursor: pointer;
}
`
export const StyledNavbarSearchSection = styled.div`

width: 60%;
height: 80px;
background-color: rgba(249, 250, 251, .75);
display: flex;
align-items: center;
padding-left: 12px;
`
export const StyledNavbarSearchButton = styled.button`
background: none;
width: 33px;
height: 33px;
border-radius: 15px;
border: none;
color: #637380;
&:hover{
    cursor: pointer;
    background-color: #EDEFF1;
    
}
`

export const StyledNavbarNotificationAndProfileSection = styled.div`

width: 16%;
height: 80px;
background-color: rgba(249, 250, 251, .75);
display: flex;
align-items: center;
justify-content: center;

`
export const StyledNotificationButton = styled.button`
background: none;
width: 35px;
height: 35px;
border-radius: 15px;
border: none;
margin-right: 16px;
&:hover{
    cursor: pointer;
    background-color: #EDEFF1;
    
    
}

`
export const StyledProfileButton = styled.button`
background: none;
width: 35px;
height: 35px;
border-radius: 15px;
border: none;
&:hover{
    cursor: pointer;
    background-color: #EDEFF1;
    
}
`